import React, { useState } from "react";
import Zoom from "react-reveal/LightSpeed";

const Contactus = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        company: "",
        service: "",
        message: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        console.log("Contact Form Data:", formData);

        // Email / backend integration will be added later.
    };

    return (
        <div
            className="himsal-contact-page"
            style={{
                fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                backgroundColor: "#f8fafc",
                color: "#0f172a",
                width: "100%",
                overflowX: "hidden"
            }}
        >

            {/* =====================================================
                HERO
            ===================================================== */}
            <section
                style={{
                    background:
                        "linear-gradient(135deg, #07162c 0%, #0b1f3a 55%, #12345b 100%)",
                    padding: "90px 20px",
                    color: "#ffffff",
                    textAlign: "center",
                    position: "relative",
                    overflow: "hidden",
                    boxSizing: "border-box"
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        width: "420px",
                        height: "420px",
                        borderRadius: "50%",
                        backgroundColor: "rgba(59,130,246,0.08)",
                        top: "-210px",
                        right: "-120px",
                        pointerEvents: "none"
                    }}
                />

                <div
                    className="container"
                    style={{
                        position: "relative",
                        zIndex: 2
                    }}
                >
                    <Zoom>
                        <div
                            style={{
                                display: "inline-block",
                                padding: "8px 16px",
                                borderRadius: "50px",
                                backgroundColor:
                                    "rgba(59,130,246,0.14)",
                                border:
                                    "1px solid rgba(96,165,250,0.25)",
                                color: "#93c5fd",
                                fontSize: "12px",
                                fontWeight: "800",
                                letterSpacing: "1.5px",
                                marginBottom: "20px"
                            }}
                        >
                            GET IN TOUCH
                        </div>

                        <h1
                            style={{
                                fontSize: "clamp(2.2rem, 7vw, 4rem)",
                                fontWeight: "800",
                                lineHeight: "1.12",
                                letterSpacing: "-1px",
                                margin: "0 auto 20px",
                                maxWidth: "850px",
                                color: "#ffffff"
                            }}
                        >
                            Let's Talk About
                            <br />
                            <span style={{ color: "#60a5fa" }}>
                                Your Business Requirement
                            </span>
                        </h1>

                        <p
                            style={{
                                color: "#cbd5e1",
                                maxWidth: "700px",
                                margin: "0 auto",
                                fontSize: "16px",
                                lineHeight: "1.8"
                            }}
                        >
                            Looking for professionals, finance outsourcing,
                            third-party payroll, IT services or a technology
                            solution? Tell us what you need.
                        </p>
                    </Zoom>
                </div>
            </section>

            {/* =====================================================
                MAIN CONTACT SECTION
            ===================================================== */}
            <section
                style={{
                    padding: "60px 20px 90px",
                    backgroundColor: "#f8fafc",
                    boxSizing: "border-box"
                }}
            >
                <div
                    className="container"
                    style={{
                        maxWidth: "1180px",
                        margin: "0 auto",
                        width: "100%"
                    }}
                >
                    <div className="himsal-contact-grid">

                        {/* =================================================
                            LEFT SIDE
                        ================================================= */}
                        <div
                            className="himsal-contact-info"
                            style={{
                                background:
                                    "linear-gradient(145deg, #07162c 0%, #0b1f3a 100%)",
                                borderRadius: "16px",
                                padding: "40px",
                                color: "#ffffff",
                                boxSizing: "border-box"
                            }}
                        >
                            <div
                                style={{
                                    color: "#60a5fa",
                                    fontSize: "12px",
                                    fontWeight: "800",
                                    letterSpacing: "1.5px",
                                    marginBottom: "12px"
                                }}
                            >
                                CONTACT HIMSAL
                            </div>

                            <h2
                                style={{
                                    color: "#ffffff",
                                    fontSize: "30px",
                                    fontWeight: "800",
                                    lineHeight: "1.25",
                                    margin: "0 0 18px"
                                }}
                            >
                                Tell Us What
                                <br />
                                You Need
                            </h2>

                            <p
                                style={{
                                    color: "#94a3b8",
                                    fontSize: "14px",
                                    lineHeight: "1.8",
                                    margin: "0 0 35px"
                                }}
                            >
                                Whether you need a professional, a dedicated
                                team, an outsourced business function or a
                                technology solution, our team is ready to
                                understand your requirement.
                            </p>

                            {/* ADDRESS */}
                            <div
                                className="himsal-contact-detail"
                            >
                                <div className="himsal-contact-icon-box">
                                    📍
                                </div>

                                <div>
                                    <div className="himsal-detail-title">
                                        Office
                                    </div>

                                    <div className="himsal-detail-text">
                                        204, 2nd Floor, Utkarsh Tower,
                                        <br />
                                        32, Block E, Laxmi Nagar,
                                        <br />
                                        Delhi - 110092
                                    </div>
                                </div>
                            </div>

                            {/* EMAIL */}
                            <a
                                href="mailto:info@himsal.in"
                                className="himsal-contact-detail himsal-contact-anchor"
                            >
                                <div className="himsal-contact-icon-box">
                                    ✉️
                                </div>

                                <div>
                                    <div className="himsal-detail-title">
                                        Email
                                    </div>

                                    <div className="himsal-email">
                                        info@himsal.in
                                    </div>
                                </div>
                            </a>

                            {/* PHONE */}
                            <a
                                href="tel:+919576755755"
                                className="himsal-contact-detail himsal-contact-anchor"
                            >
                                <div className="himsal-contact-icon-box">
                                    📞
                                </div>

                                <div>
                                    <div className="himsal-detail-title">
                                        Phone
                                    </div>

                                    <div className="himsal-email">
                                        +91 9576 755 755
                                    </div>
                                </div>
                            </a>

                            {/* WHATSAPP */}
                            <a
                                href="https://wa.me/919576755755"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="himsal-whatsapp-button"
                            >
                                💬 Chat on WhatsApp
                            </a>
                        </div>

                        {/* =================================================
                            RIGHT SIDE FORM
                        ================================================= */}
                        <div
                            className="himsal-contact-form-wrapper"
                            style={{
                                backgroundColor: "#ffffff",
                                borderRadius: "16px",
                                padding: "40px",
                                border: "1px solid #e2e8f0",
                                boxShadow:
                                    "0 8px 30px rgba(15,23,42,0.04)",
                                boxSizing: "border-box"
                            }}
                        >
                            <div
                                style={{
                                    marginBottom: "30px"
                                }}
                            >
                                <div
                                    style={{
                                        color: "#2563eb",
                                        fontSize: "12px",
                                        fontWeight: "800",
                                        letterSpacing: "1.5px",
                                        marginBottom: "10px"
                                    }}
                                >
                                    BUSINESS ENQUIRY
                                </div>

                                <h2
                                    style={{
                                        color: "#0f172a",
                                        fontSize: "28px",
                                        fontWeight: "800",
                                        margin: "0 0 10px",
                                        lineHeight: "1.25"
                                    }}
                                >
                                    Send Us Your Requirement
                                </h2>

                                <p
                                    style={{
                                        color: "#64748b",
                                        fontSize: "14px",
                                        lineHeight: "1.7",
                                        margin: 0
                                    }}
                                >
                                    Share a few details about your requirement
                                    and our team can get in touch with you.
                                </p>
                            </div>

                            <form
                                onSubmit={handleSubmit}
                                className="himsal-form"
                            >

                                {/* NAME */}
                                <div className="himsal-form-field">
                                    <label>
                                        Full Name *
                                    </label>

                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="Your name"
                                        required
                                    />
                                </div>

                                {/* EMAIL */}
                                <div className="himsal-form-field">
                                    <label>
                                        Business Email *
                                    </label>

                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="you@company.com"
                                        required
                                    />
                                </div>

                                {/* PHONE */}
                                <div className="himsal-form-field">
                                    <label>
                                        Phone Number
                                    </label>

                                    <input
                                        type="tel"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        placeholder="+91 XXXXX XXXXX"
                                    />
                                </div>

                                {/* COMPANY */}
                                <div className="himsal-form-field">
                                    <label>
                                        Company Name
                                    </label>

                                    <input
                                        type="text"
                                        name="company"
                                        value={formData.company}
                                        onChange={handleChange}
                                        placeholder="Your company"
                                    />
                                </div>

                                {/* SERVICE */}
                                <div className="himsal-form-field">
                                    <label>
                                        What Can We Help You With? *
                                    </label>

                                    <select
                                        name="service"
                                        value={formData.service}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">
                                            Select a service
                                        </option>

                                        <option value="Finance & Accounting Outsourcing">
                                            Finance & Accounting Outsourcing
                                        </option>

                                        <option value="Professional Staffing">
                                            Professional Staffing
                                        </option>

                                        <option value="Third-Party Payroll">
                                            Third-Party Payroll
                                        </option>

                                        <option value="IT Staffing & Technology">
                                            IT Staffing & Technology
                                        </option>

                                        <option value="Website & Software Development">
                                            Website & Software Development
                                        </option>

                                        <option value="Business Process Outsourcing">
                                            Business Process Outsourcing
                                        </option>

                                        <option value="Other">
                                            Other Requirement
                                        </option>
                                    </select>
                                </div>

                                {/* MESSAGE */}
                                <div className="himsal-form-field">
                                    <label>
                                        Tell Us About Your Requirement *
                                    </label>

                                    <textarea
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        rows="5"
                                        placeholder="Tell us about your requirement, team size, project, or the business process you want to outsource..."
                                        required
                                    />
                                </div>

                                {/* BUTTON */}
                                <button
                                    type="submit"
                                    className="himsal-submit-button"
                                >
                                    Send Business Enquiry →
                                </button>

                                <div
                                    style={{
                                        textAlign: "center",
                                        color: "#94a3b8",
                                        fontSize: "11px",
                                        lineHeight: "1.5"
                                    }}
                                >
                                    Your information will be used only to
                                    respond to your enquiry.
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            {/* =====================================================
                QUICK CONTACT
            ===================================================== */}
            <section
                style={{
                    padding: "0 20px 80px",
                    backgroundColor: "#f8fafc",
                    textAlign: "center"
                }}
            >
                <div
                    style={{
                        maxWidth: "800px",
                        margin: "0 auto"
                    }}
                >
                    <h3
                        style={{
                            color: "#0f172a",
                            fontSize: "24px",
                            fontWeight: "800",
                            margin: "0 0 10px"
                        }}
                    >
                        Prefer a Quick Conversation?
                    </h3>

                    <p
                        style={{
                            color: "#64748b",
                            fontSize: "14px",
                            lineHeight: "1.7",
                            margin: "0 0 22px"
                        }}
                    >
                        Call us directly or start a conversation on WhatsApp.
                    </p>

                    <div
                        className="himsal-quick-buttons"
                    >
                        <a
                            href="tel:+919576755755"
                            className="himsal-call-button"
                        >
                            📞 Call Us
                        </a>

                        <a
                            href="https://wa.me/919576755755"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="himsal-whatsapp-small"
                        >
                            💬 WhatsApp
                        </a>
                    </div>
                </div>
            </section>

            {/* =====================================================
                RESPONSIVE CSS
            ===================================================== */}
            <style>
                {`
                    * {
                        box-sizing: border-box;
                    }

                    .himsal-contact-grid {
                        display: grid;
                        grid-template-columns:
                            minmax(280px, 0.8fr)
                            minmax(320px, 1.2fr);
                        gap: 25px;
                        align-items: stretch;
                    }

                    .himsal-contact-detail {
                        display: flex;
                        align-items: flex-start;
                        gap: 14px;
                        margin-bottom: 25px;
                    }

                    .himsal-contact-anchor {
                        text-decoration: none;
                    }

                    .himsal-contact-icon-box {
                        width: 44px;
                        height: 44px;
                        min-width: 44px;
                        border-radius: 9px;
                        background-color: rgba(59,130,246,0.14);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 18px;
                    }

                    .himsal-detail-title {
                        color: #ffffff;
                        font-weight: 700;
                        font-size: 14px;
                        margin-bottom: 4px;
                    }

                    .himsal-detail-text {
                        color: #94a3b8;
                        font-size: 13px;
                        line-height: 1.6;
                    }

                    .himsal-email {
                        color: #60a5fa;
                        font-size: 13px;
                        word-break: break-word;
                    }

                    .himsal-whatsapp-button {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        gap: 9px;
                        background-color: #25D366;
                        color: #ffffff;
                        padding: 12px 18px;
                        border-radius: 8px;
                        font-size: 13px;
                        font-weight: 800;
                        text-decoration: none;
                    }

                    .himsal-form {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 20px;
                    }

                    .himsal-form-field {
                        width: 100%;
                    }

                    .himsal-form-field label {
                        display: block;
                        color: #334155;
                        font-size: 13px;
                        font-weight: 700;
                        margin-bottom: 8px;
                    }

                    .himsal-form-field input,
                    .himsal-form-field select,
                    .himsal-form-field textarea {
                        width: 100%;
                        max-width: 100%;
                        box-sizing: border-box;
                        border: 1px solid #cbd5e1;
                        border-radius: 8px;
                        padding: 13px 14px;
                        font-size: 14px;
                        font-family: inherit;
                        color: #334155;
                        background-color: #ffffff;
                        outline: none;
                    }

                    .himsal-form-field input,
                    .himsal-form-field select {
                        height: 47px;
                    }

                    .himsal-form-field textarea {
                        resize: vertical;
                        min-height: 120px;
                        line-height: 1.6;
                    }

                    .himsal-form-field input:focus,
                    .himsal-form-field select:focus,
                    .himsal-form-field textarea:focus {
                        border-color: #2563eb;
                        box-shadow: 0 0 0 3px rgba(37,99,235,0.08);
                    }

                    .himsal-form-field:nth-child(5),
                    .himsal-form-field:nth-child(6),
                    .himsal-submit-button {
                        grid-column: 1 / -1;
                    }

                    .himsal-submit-button {
                        width: 100%;
                        border: none;
                        background-color: #2563eb;
                        color: #ffffff;
                        padding: 15px;
                        border-radius: 8px;
                        font-size: 15px;
                        font-weight: 800;
                        cursor: pointer;
                        font-family: inherit;
                    }

                    .himsal-quick-buttons {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        gap: 12px;
                        flex-wrap: wrap;
                    }

                    .himsal-call-button,
                    .himsal-whatsapp-small {
                        padding: 13px 22px;
                        border-radius: 8px;
                        text-decoration: none;
                        font-size: 14px;
                        font-weight: 700;
                    }

                    .himsal-call-button {
                        background-color: #0b1f3a;
                        color: #ffffff;
                    }

                    .himsal-whatsapp-small {
                        background-color: #25D366;
                        color: #ffffff;
                    }

                    /* ================================================
                       TABLET
                    ================================================= */
                    @media (max-width: 900px) {
                        .himsal-contact-grid {
                            grid-template-columns: 1fr;
                        }

                        .himsal-contact-info {
                            width: 100%;
                        }

                        .himsal-contact-form-wrapper {
                            width: 100%;
                        }
                    }

                    /* ================================================
                       MOBILE
                    ================================================= */
                    @media (max-width: 600px) {
                        .himsal-contact-page section {
                            width: 100%;
                        }

                        .himsal-contact-grid {
                            display: flex;
                            flex-direction: column;
                            gap: 20px;
                        }

                        .himsal-contact-info {
                            padding: 28px 22px !important;
                            border-radius: 12px !important;
                        }

                        .himsal-contact-form-wrapper {
                            padding: 28px 20px !important;
                            border-radius: 12px !important;
                        }

                        .himsal-contact-info h2 {
                            font-size: 25px !important;
                        }

                        .himsal-contact-form-wrapper h2 {
                            font-size: 24px !important;
                        }

                        .himsal-form {
                            display: flex;
                            flex-direction: column;
                            gap: 18px;
                        }

                        .himsal-form-field {
                            width: 100%;
                        }

                        .himsal-form-field input,
                        .himsal-form-field select,
                        .himsal-form-field textarea {
                            width: 100% !important;
                            max-width: 100% !important;
                        }

                        .himsal-submit-button {
                            width: 100%;
                            margin-top: 3px;
                        }

                        .himsal-whatsapp-button {
                            width: 100%;
                            box-sizing: border-box;
                        }

                        .himsal-quick-buttons {
                            flex-direction: column;
                            width: 100%;
                        }

                        .himsal-call-button,
                        .himsal-whatsapp-small {
                            width: 100%;
                            box-sizing: border-box;
                            display: block;
                        }
                    }

                    /* ================================================
                       SMALL MOBILE
                    ================================================= */
                    @media (max-width: 380px) {
                        .himsal-contact-page section {
                            padding-left: 15px !important;
                            padding-right: 15px !important;
                        }

                        .himsal-contact-info {
                            padding: 25px 18px !important;
                        }

                        .himsal-contact-form-wrapper {
                            padding: 25px 16px !important;
                        }

                        .himsal-contact-detail {
                            gap: 10px;
                        }

                        .himsal-contact-icon-box {
                            width: 40px;
                            height: 40px;
                            min-width: 40px;
                        }

                        .himsal-detail-text,
                        .himsal-email {
                            font-size: 12px;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default Contactus;
